import { Component, OnInit } from '@angular/core';
import { Caisse } from 'src/app/common/model/caisse';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FormFactory } from 'src/app/shared/form-factory';
import { CaisseService } from './caisse.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-caisse-form',
  templateUrl: './caisse-form.component.html',
  styleUrls: ['./caisse-form.component.scss']
})
export class CaisseFormComponent implements OnInit {

  caisse: Caisse = {} as Caisse;  // BEAN
  formGroup: FormGroup;           // FORM (initialisé avec FormFactory)

  beanId: number = null;  // Si formulaire en mode édition, c'est l'id du bean concerné
  editionMode = true;     // Permet de savoir si formulaire en mode ajout ou edition
  loading = false;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private caisseService: CaisseService) {
      this.beanId = +this.route.snapshot.params.id;
      if ( !this.beanId ) {
        this.beanId = null;
        this.editionMode = false;
      }
    }


  ngOnInit() {
    this.formGroup = this.fb.group( FormFactory.createFormCaisse(this.editionMode) );
    if (this.editionMode) {
      this.refreshBean();
    }
  }

  form(val) {
    return this.formGroup.controls[val];
  }

  switchToEditionMode() {
    this.editionMode = true;
    this.beanId = this.caisse.id;
  }

  async refreshBean() {
    try {
      this.loading = true;
      this.caisse = await this.caisseService.get(this.beanId).toPromise();
      this.formGroup.patchValue( this.caisse );
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  }

  isFormValid() {
    return this.formGroup.valid;
  }

  askBack() {
    window.history.back();
  }

  async askSave() {
    try {
      this.loading = true;
      this.caisse = await this.caisseService.save(this.formGroup.value).toPromise();
      this.formGroup.patchValue( this.caisse );
      this.askBack();
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  }

}
